import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link, Stack } from "@mui/material";
import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { getSavedWasteSubmissionsUrl } from "routes/Customer/Waste/Submissions/navigation";

interface SubmissionHeaderNavigationProps {
  tenantId: string;
  actions?: ReactNode;
}

export function SubmissionHeaderNavigation({ tenantId, actions }: SubmissionHeaderNavigationProps) {
  const submissionsUrl = getSavedWasteSubmissionsUrl(tenantId);

  return (
    <Stack
      id="submission-header"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      paddingX={3}
      paddingY={2}
      sx={{
        backgroundColor: "background.paper",
        borderBottom: "1px solid",
        borderBottomColor: "divider",
      }}
    >
      <Link
        component={RouterLink}
        to={submissionsUrl}
        sx={{
          textDecoration: "none",
          color: "primary.main",
          display: "inline-flex",
          alignItems: "center",
          fontSize: "14px",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        <ChevronLeftIcon sx={{ mr: 0.5, fontSize: 18 }} />
        ALL SUBMISSIONS
      </Link>
      {actions}
    </Stack>
  );
}
